// https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
export const VIDEO_AVAILABLE_MIME_TYPES = [
  { name: 'mp4', value: 'video/mp4' },
  { name: 'webm', value: 'video/webm' },
]

export const DOCUMENT_AVAILABLE_MIME_TYPES = [
  {
    name: 'docx',
    value: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  },
  { name: 'doc', value: 'application/msword' },
  { name: 'xlsx', value: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' },
  { name: 'xls', value: 'application/vnd.ms-excel' },
  {
    name: 'pptx',
    value: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  },
  { name: 'ppt', value: 'application/vnd.ms-powerpoint' },
  { name: 'pdf', value: 'application/pdf' },
]

export const IMAGE_AVAILABLE_MIME_TYPES = [
  { name: 'jpg', value: 'image/jpeg' },
  { name: 'png', value: 'image/png' },
]

export const FILE_AVAILABLE_MIME_TYPES = [
  ...DOCUMENT_AVAILABLE_MIME_TYPES,
  ...VIDEO_AVAILABLE_MIME_TYPES,
]
